var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('counsel-card-row', {
    attrs: {
      "label": "분야",
      "cols": 12,
      "md": 4
    }
  }, [_vm._v(" " + _vm._s(_vm.areaText) + " ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }